module.exports = __webpack_public_path__ + "media/img/specialize/item5-fa8fbca45f28f336df6546f1c51ff312.svg";